<section class="container-fluid">
  <div #buttonsContainer class="row mb-2 d-flex justify-content-between container-style">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 gap-1 d-flex justify-content-end">
      <app-custom-button [title]="'Imprimir'" [label]="'Imprimir'" [severity]="'success'" [icon]="'pi pi-print'"
        [width]="'6rem'" (onClick)="printDocument()"></app-custom-button>

      <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [severity]="'success'" [icon]="'pi pi-file-export'"
        [width]="'6rem'" (onClick)="exportContab()"></app-custom-button>
      <app-custom-button [title]="'Recalcular'" [label]="'Recalcular'" [severity]="'primary'" [variant]="undefined"
        [icon]="'pi pi-sync'" [width]="'6rem'" (onClick)="recalculate()"></app-custom-button>
    </div>
  </div>
  <div #dataIntreface *ngIf="visibleTable" class="row container-style">
    <div class=" col-12 custom-table-container mb-1">
      <app-custom-table-report [dataReport]="dataReport" [extraMargin]="280"
        [virtualScroll]="true"></app-custom-table-report>
    </div>
  </div>
  <app-custom-modal
    #siesaSynchronizationModal
    [header]="'Sincronización con Siesa Cloud'"
    [width]="'60vw'"
    [children]="componentSynchronizer"
    [inputs$]="inputsForSynchronizer$"
    hidden
  ></app-custom-modal>
</section>